import React from 'react';
import './DeleteConfirmationModal.css'; 

interface DeleteConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  itemName: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ onClose, onConfirm, isDeleting, itemName }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Confirm Deletion</h2>
        <p>Are you sure you want to delete the vendor "<strong>{itemName}</strong>"? This action cannot be undone.</p>
        <div className="modal-actions">
          <button type="button" className="btn-cancel" onClick={onClose} disabled={isDeleting}>Cancel</button>
          <button type="button" className="btn-delete" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;